import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { setQuestion } from 'src/app/actions/question.actions';
import { Question } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { fromTest } from 'src/app/reducers/test.reducer';
import { QuestionService } from 'src/app/services/question.service';

@Component({
  selector: 'ct-reasoning-example',
  templateUrl: './reasoning-example.component.html',
  styleUrls: ['./reasoning-example.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReasoningExampleComponent implements OnInit {

  @Input() colors: any;

  public question$: Observable<Question>;
  public test$: Observable<Test>;

  constructor(
    private store: Store,
    private questionService: QuestionService
  ) { }

  ngOnInit(): void {
    // obtenemos los datos de la pregunta y el test de la store
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));
  }

  goToQuestions() {
    this.test$.subscribe(test => {
      this.questionService.getNextQuestion(test.token).subscribe(questions => {
        this.store.dispatch(setQuestion(questions));
      });
    });
  }

}
